var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.533,
    height: 21.995,
    viewBox: "0 0 17.533 21.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 371",
    d: "M452.508 2010.485h-1.526v-3.507a4.62 4.62 0 0 0-1.43-3.26c-.1-.1-.217-.171-.325-.258l-.047-.037a4.622 4.622 0 0 0-.719-.463l-.013-.006a4.517 4.517 0 0 0-.819-.326l-.023-.007a4.652 4.652 0 0 0-.861-.159l-.056-.006c-.119-.008-.235-.033-.355-.033h-.1a4.641 4.641 0 0 0-4.554 4.555v3.506h-1.523a2.6 2.6 0 0 0-2.592 2.593v8.748a2.6 2.6 0 0 0 2.592 2.593h12.349a2.6 2.6 0 0 0 2.592-2.593v-8.748a2.6 2.6 0 0 0-2.59-2.592zm-9.074-3.505a2.9 2.9 0 0 1 2.9-2.806h.093a2.9 2.9 0 0 1 2.8 2.8v3.506h-5.793zm9.912 14.847a.838.838 0 0 1-.838.841H440.16a.842.842 0 0 1-.839-.838v-8.751a.841.841 0 0 1 .839-.838h12.349a.839.839 0 0 1 .838.838z",
    transform: "translate(-437.566 -2002.423)",
    style: {
      fill: "#254089"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 372",
    d: "M448.308 2017.636a1.992 1.992 0 0 0-1.26 3.536v1.709a1.26 1.26 0 0 0 2.521 0v-1.709a1.992 1.992 0 0 0-1.26-3.536zm.662 3.012-.177.115v2.117a.485.485 0 1 1-.97 0v-2.117l-.177-.115a1.218 1.218 0 1 1 1.323 0z",
    transform: "translate(-439.542 -2005.861)",
    style: {
      fill: "#254089"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLockIcon);
export default __webpack_public_path__ + "static/media/blue-lock-icon.9f8349c38a33ab0cc825f3d3735cd599.svg";
export { ForwardRef as ReactComponent };